module.exports = __webpack_public_path__ + "static/looking_off-3cebafa1ffc9d30ef353c4eb3b6868c8.jpg";